<button :class="classes" :disabled="disabled" v-on="$listeners" type="button">
  <slot></slot>
</button>


// WEBPACK FOOTER //
// ./src/objects/button/button.html